<template>
  <div class="tl">
    <Menu />
    <div class="sllocalization">
      <section class="bnr">
        <div class="contBx">
          <div class="desc">
            <div>
              <h1 class="title">深耕信创</h1>
              <h1 class="title">ToDesk引领国产远控</h1>
              <h2 class="subTitle subTitle1">
                提供高兼容性、高稳定性的远程控制解决方案
              </h2>
              <h2 class="subTitle">
                帮助客户快速推进信创建设，高效赋能远程办公、远程运维
              </h2>
            </div>
            <div class="btns">
              <a
                class="link_btn btn1 epBtn1"
                href="https://console.todesk.com/#/register"
                >免费试用</a
              >
              <a
                class="link_btn btn2 epBtn2"
                href="/#/contact_mobile"
                >立即咨询方案</a
              >
            </div>
          </div>
          <div class="mainPicBx">
            <img
              class="mainPic"
              src="https://todeskcdnspeed.todesk.com/mobile/common/bnrpic.png"
              alt="ToDesk企业版"
            />
          </div>
        </div>
      </section>
      <section class="partner" v-if="logo_list.length > 0">
        <div class="title">更多中国企业信赖</div>
        <div class="img">
          <img
            v-for="(item, index) in logo_list"
            :key="index"
            :src="item"
            alt=""
            class="logo_item"
          />
        </div>
      </section>
      <section class="techf_desc">
        <h2 class="dtitle">100%自主可控，为信创量身打造的远程控制</h2>
      </section>
      <section class="feature feature3">
        <div class="fr_bx">
          <div class="imginfo">
            <img src="https://todeskcdnspeed.todesk.com/mobile/common/localization_fr1.png" alt="深度适配国产操作系统" />
          </div>
          <div class="datainfo">
            <h3 class="title">
              <span class="t1">深度适配国产操作系统</span>
            </h3>
            <div class="desc_item">
              <span class="desc_text"
                >现已全面支持统信UOS、银河麒麟、中科方德等操作系统</span
              >
            </div>
            <div class="desc_item">
              <span class="desc_text">共建信创生态</span>
            </div>
            <a
              class="link_btn btn1 epBtn1"
              href="https://console.todesk.com/#/register"
              >立即咨询方案</a
            >
          </div>
        </div>
      </section>
      <section class="feature feature1">
        <div class="fr_bx">
          <div class="imginfo">
            <img src="https://todeskcdnspeed.todesk.com/mobile/common/localization_fr2.png" alt="" />
          </div>
          <div class="datainfo">
            <h3 class="title">
              <span class="t1">全面兼容中国芯</span>
            </h3>
            <div class="desc_item">
              <span class="desc_text"
                >适配飞腾、鲲鹏、兆芯、海光、海思麒麟等国产CPU</span
              >
            </div>
            <div class="desc_item">
              <span class="desc_text">“全芯”支持，远程加速</span>
            </div>
          </div>
          <a
            class="link_btn btn1 epBtn1"
            href="https://console.todesk.com/#/register"
            >立即咨询方案</a
          >
        </div>
      </section>
      <section class="feature feature2">
        <div class="fr_bx">
          <div class="imginfo">
            <img src="https://todeskcdnspeed.todesk.com/mobile/common/localization_fr3.png" alt="深度适配国产操作系统" />
          </div>
          <div class="datainfo">
            <h3 class="title">
              <span class="t1">跨系统操作流畅更安全</span>
            </h3>
            <div class="desc_item">
              <span class="desc_text">支持Windows与各国产系统远程互连</span>
            </div>
            <div class="desc_item">
              <span class="desc_text">稳定访问，全流程安全防护</span>
            </div>
            <a
              class="link_btn btn1 epBtn1"
              href="https://console.todesk.com/#/register"
              >立即咨询方案</a
            >
          </div>
        </div>
      </section>
      <section class="safe_design">
        <h2 class="sd_title">多维安全设计<br />满足信创安全管理要求</h2>
        <div class="sd_bx">
          <div class="sd_item" v-for="(item, index) in safe_list" :key="index">
            <img
              :src="require(`@/assets/common/safe_icon${index}.png`)"
              alt=""
            />
            <p v-for="(pitem, pindex) in item" :key="pindex">{{ pitem }}</p>
          </div>
        </div>
      </section>
      <localizationCom1 />
      <PrivateDP />
      <CmptCertification />
      <div class="certification_bx">
        <h2 class="certification_bx_title">相关资质证书</h2>
        <div class="certification_bx_imgs">
          <img
            class="certification_bx_img"
            src="https://todeskcdnspeed.todesk.com/202308246037a115352e22cacf17.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from "@/components/menu";
import Footer from "@/components/footer";
import { mapState } from "vuex";
import { videoReady } from "../../utils/util";
import localizationCom1 from "@/components/Common/localizationCom1";
import CmptCertification from "@/components/Common/CmptCertification";
// import EpSide from '@/components/Enterprise/EpSide'
import PrivateDP from "@/components/Common/PrivateDP";
export default {
  components: {
    Menu,
    Footer,
    localizationCom1,
    PrivateDP,
    CmptCertification,
  },
  data() {
    return {
      logo_list: [
        "https://todeskcdnspeed.todesk.com/mobile/common/localization_vic2.png",
        "https://todeskcdnspeed.todesk.com/mobile/common/localization_shangqi.png",
        "https://todeskcdnspeed.todesk.com/mobile/common/localization_bohai2.png",
        "https://todeskcdnspeed.todesk.com/mobile/common/localization_guangqukeji2.png",
      ],
      safe_list: [
        ["灵活配置操作权限", "文件传输/复制粘贴/截屏"],
        ["可设明/暗水印", "防止企业信息外流"],
        ["服务端加密录屏", "操作过程均可回查"],
        ["详细连接日志", "永久保存"],
      ],
    };
  },
  mounted() {
    // this.setEfficacyChange();
  },
  methods: {
    setEfficacyChange() {
      this.efficacy_timer = setInterval(() => {
        let next_index = 0;
        if (this.efficacy_index != 3) {
          next_index = this.efficacy_index;
          next_index++;
        }
        this.startEfficacyChange(next_index);
      }, 5000);
    },
  },
};
</script>
<style lang="less" scoped>
.sllocalization {
  .bnr {
    background: linear-gradient(135deg, #e1eafb 0%, #e1eafb 100%);
    .contBx {
      width: 100%;
      margin: auto;
      .desc {
        padding-top: 45px;
        .title {
          font-size: 30px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #222429;
          line-height: 42px;
          text-align: center;
        }

        .subTitle {
          width: 337px;
          margin: 0 auto;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #585f69;
          line-height: 20px;
          text-align: center;
        }
        .subTitle1 {
          margin-top: 17px;
        }

        .btns {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 32px;
          .btn1 {
            height: 48px;
            width: 160px;
            line-height: 48px;
          }
          .btn2 {
            height: 48px;
            width: 160px;
            line-height: 48px;
          }
        }
        .link_btn {
          margin-left: 8px;
          margin-right: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .mainPicBx {
        padding-top: 36px;
        width: 345px;
        margin: 0 auto;
      }
      .mainPic {
        width: 100%;
      }
    }
  }
  .partner {
    background: #fff;
    padding: 40px 40px 16px;
    .title {
      font-size: 24px;
      line-height: 34px;
      color: #222429;
      text-align: center;
      margin-bottom: 20px;
      font-weight: bold;
    }
    .img {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .logo_item {
        height: 36px;
        margin-bottom: 24px;
      }
    }
  }
  .feature {
    .fr_bx {
      width: 100%;
      display: flex;
      justify-content: center;
      flex-flow: row wrap;
      align-items: center;
      flex-direction: column;
      margin: auto;
    }
    .datainfo {
      flex: 1;
      box-sizing: border-box;
      .title {
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        line-height: 28px;
        margin-top: 40px;
        margin-bottom: 18px;
        text-align: center;
        .t1 {
          color: #222429;
        }
        .t2 {
          color: #0065dd;
        }
      }
      .desc_item {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #585f69;
        line-height: 20px;
        text-align: center;
      }
      .info {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #585f69;
        line-height: 22px;
        margin-bottom: 20px;
      }
      .trail {
        margin-top: 40px;
        width: 156px;
        height: 48px;
        line-height: 48px;
        border-radius: 4px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
      }
    }
    .imginfo {
      width: 328px;
      img {
        width: 100%;
      }
    }
    .link_btn {
      display: block;
      height: 44px;
      width: 200px;
      line-height: 44px;
      margin: 0 auto;
      margin-top: 18px;
      font-size: 18px;
    }
  }
  .feature1 {
    background: #fff;
    padding-top: 40px;
    padding-bottom: 40px;
  }
  .techf_desc {
    padding-top: 40px;
    text-align: center;
    background: #f6f6f8;
    .dtitle {
      width: 340px;
      text-align: center;
      font-size: 26px;
      line-height: 36px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222429;
      margin: 0 auto;
    }
  }
  .feature2 {
    padding-top: 40px;
    padding-bottom: 40px;
    background: #f6f8fc;
  }
  .feature3 {
    padding-top: 20px;
    padding-bottom: 40px;
    background: #f6f8fc;
  }

  .safe_design {
    padding-top: 40px;
    padding-bottom: 40px;
    background: #fff;
    .sd_title {
      width: 260px;
      font-size: 26px;
      line-height: 36px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222429;
      text-align: center;
      margin: 0 auto;
    }
    .sd_bx {
      display: flex;
      justify-content: center;
      flex-flow: row wrap;
      padding-top: 20px;
      .sd_item {
        width: 50%;
        text-align: center;
        padding: 20px 0;
        img {
          width: 62px;
          height: 62px;
          margin-bottom: 8px;
          margin: auto;
        }
        p {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #222429;
          line-height: 20px;
        }
      }
    }
  }
  .certification_bx {
    text-align: center;
    padding-top: 40px;
    padding-bottom: 40px;
    .certification_bx_title {
      font-size: 26px;
      font-weight: 600;
      color: #222429;
      text-align: center;
    }
    .certification_bx_imgs {
      text-align: center;
      padding-top: 20px;
      .certification_bx_img {
        height: auto;
        width: 345px;
        display: inline;
      }
    }
  }
}
</style>
